import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { BookOpen, Loader2, RefreshCw } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const UpdateAllGuides = () => {
  const [s, setS] = useState(null);
  const load = useCallback(() => api.get("/guides-update-all").then((r) => setS(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { if (!s?.running) return undefined; const t = setInterval(load, 15000); return () => clearInterval(t); }, [s?.running, load]);
  if (!s) return null;
  const start = async () => {
    if (!window.confirm(`Update all ${s.eligible} town guides to the new 15-chapter edition? They run one at a time (about 6-8 minutes each), each uses AI credit, past buyers get the new edition by email, and the current editions stay on sale meanwhile.`)) return;
    try { await api.post("/guides-update-all"); toast.success("Updating all guides, one at a time"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="border border-[#E2D9CC] bg-[#FAF7F2] p-5 mb-6 flex flex-wrap items-center gap-4" data-testid="update-all-guides">
      <BookOpen className="w-5 h-5 text-[#C59B27]" strokeWidth={1.5} />
      <div className="mr-auto">
        <p className="eyebrow mb-1">New chapters: expat community · health, vets &amp; pets · children · property costs · tax</p>
        {s.running
          ? <p className="text-sm" data-testid="update-all-progress">Updating… {s.done} of {s.total} guides done{s.current ? `, now writing ${s.current}` : ""}{s.failed ? ` · ${s.failed} failed` : ""}</p>
          : <p className="text-sm text-[#8C827A]" data-testid="update-all-status">{s.finished_at ? `Last run: ${s.done - s.failed} of ${s.total} guides updated${s.failed_towns?.length ? ` (failed: ${s.failed_towns.join(", ")})` : ""}.` : `New guides get these chapters automatically. ${s.eligible} existing guides can be updated.`}</p>}
      </div>
      <Button onClick={start} disabled={s.running || !s.eligible} className="rounded-none" data-testid="update-all-button">
        {s.running ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}{s.running ? "Updating guides…" : "Update all guides"}
      </Button>
    </div>
  );
};
